import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 登录注册等接口
export default {
  productList(params) { // 产品列表
    const url =  baseURL + '/tbUser/getUserModule';
    return axios.post(url, qs.stringify(params));
  },
  productListImg(params) { // 产品列表
    const url =  baseURL + '/tbUser/createCode';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/product.js